import React                                                                                                                    from 'react';
import { PluginDocumentSettingPanel }                                                                                           from '@wordpress/edit-post';
import { RadioControl, __experimentalNumberControl as NumberControl }                                                           from '@wordpress/components';
import { __ }                                                                                                                    from '@wordpress/i18n';
import withMetaboxValidation                                                                                                    from './withMetaboxValidation';
import { OrderBumpsMeta, ValidationRules }                                                                                      from '../../Types/ValidationRules';

const getValidationRules: ( meta: OrderBumpsMeta ) => ValidationRules = ( meta ) => ( {

} );

const OrderBumpsOfferDiscountPanel = ( { meta, handleFieldChange } ) => (
    <PluginDocumentSettingPanel
        name="cfw-ob-offer-discount"
        title={__( 'Offer Discount', 'checkout-wc' )}
        className="cfw-ob-offer-discount-mb"
    >
        <RadioControl
            label={__( 'Discount Type', 'checkout-wc' )}
            help={__( 'Amount Off: Remove fixed amount from the product price. Percent Off: Discount product by specified percentage.', 'checkout-wc' )}
            selected={ meta.cfw_ob_discount_type }
            options={ [
                { label: __( 'Percent Off', 'checkout-wc' ), value: 'percent' },
                { label: __( 'Amount Off', 'checkout-wc' ), value: 'amount' },
            ] }
            onChange={
                ( newValue: any ) => {
                    handleFieldChange( 'cfw_ob_discount_type', newValue );
                }
            }
        />

        <NumberControl
            label={__( 'Discount', 'checkout-wc' )}
            help={__( 'The amount or percentage applied as a discount to the Offer Product. Leave blank or enter 0 to charge full price.', 'checkout-wc' )}
            value={ meta.cfw_ob_offer_discount }
            onChange={
                ( newValue: string ) => {
                    handleFieldChange( 'cfw_ob_offer_discount', newValue );
                }
            }
        />

        {meta.cfw_ob_upsell !== 'yes'
                && <RadioControl
                    label={__( 'Item Removal Behavior', 'checkout-wc' )}
                    help={__( 'What happens when the display for product is removed from the cart. Default: Order Bump remains in the cart but bump specific discounts are removed.', 'checkout-wc' )}
                    selected={ meta.cfw_ob_item_removal_behavior }
                    options={ [
                        { label: __( 'Leave In Cart With Normal Price', 'checkout-wc' ), value: 'keep' },
                        { label: __( 'Remove Order Bump From Cart', 'checkout-wc' ), value: 'delete' },
                    ] }
                    onChange={
                        ( newValue: any ) => {
                            handleFieldChange( 'cfw_ob_item_removal_behavior', newValue );
                        }
                    }
                />
        }
    </PluginDocumentSettingPanel>
);

export default withMetaboxValidation( OrderBumpsOfferDiscountPanel, getValidationRules );
